// @ts-nocheck
import { useWeb3React } from '@web3-react/core'
import useLocalDispatch from 'contexts/LocalRedux/useLocalDispatch'
import { useAccountLocalEventListener } from 'hooks/useAccountLocalEventListener'
import { useEffect } from 'react'
import { useBlockNumber } from 'state/application/hooks'
import { initializePredictions } from 'state/predictions'
import styled from 'styled-components'
import { useMatchBreakpoints } from 'uikit'

import Container from './components/Container'
import SwiperProvider from './context/SwiperProvider'
import Desktop from './Desktop'
import usePollPredictions from './hooks/usePollPredictions'
import Mobile from './Mobile'

const StyledContainer = styled(Container)`
  min-height: 830px;
`

const Predictions = () => {
  const { isDesktop } = useMatchBreakpoints()
  const { account } = useWeb3React()
  const dispatch = useLocalDispatch()
  const block = useBlockNumber()
  useAccountLocalEventListener()

  useEffect(() => {
    if (block > 0) {
      // Do not start initialization until the first block has been retrieved
      dispatch(initializePredictions(account))
    }
  }, [block, dispatch, account])

  usePollPredictions()

  return (
    <>
      <SwiperProvider>
        <StyledContainer>
          {isDesktop ? <Desktop /> : <Mobile />}
          {/* <CollectWinningsPopup /> */}
        </StyledContainer>
      </SwiperProvider>
    </>
  )
}

export default Predictions
